import { DailyAttendanceReportUIProvider } from "./DailyAttendanceReportUIContext";
import { DailyAttendanceReportCard } from "./DailyAttendanceReportCard";

export function DailyAttendanceReportPage() {
  return (
    <DailyAttendanceReportUIProvider>
      <DailyAttendanceReportCard />
    </DailyAttendanceReportUIProvider>
 );
}